<script setup>
import { onMounted, ref } from 'vue'

/** A new build of the panel is ready: offer to reload rather than swap it underneath somebody. */
const needRefresh = ref(false)
let update = null
onMounted(async () => {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return
  try {
    const { registerSW } = await import('virtual:pwa-register')
    update = registerSW({ onNeedRefresh: () => (needRefresh.value = true) })
  } catch {
    // no service worker in this build
  }
})
</script>

<template>
  <div v-if="needRefresh" class="flex items-center gap-3 bg-brand-600 px-4 py-2 text-sm text-white">
    <i class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
    <span class="flex-1">{{ $t('messages.updateAvailable') }}</span>
    <button type="button" class="rounded bg-white/20 px-3 py-1 font-medium hover:bg-white/30" @click="update && update(true)">{{ $t('messages.reload') }}</button>
  </div>
</template>
